import '../App.css';
import { useNavigate } from 'react-router-dom';
import UserRegister from '../model/request/UserRegister.js';
import { useEffect, useState } from 'react';
import TopBar from './TopBar.js';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import LookUpRequest from "../model/request/LookupRequest";
import RegisteredUserResponse from '../model/response/RegisteredUserResponse.js';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import logo from '../images/logo.jpeg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Offeradd from './Offeradd.js';

function Profile() {
  const navigation = useNavigate();

  // Load saved form data from localStorage if available
 const savedFormData = JSON.parse(localStorage.getItem('profileFormData') || '{}');

  // Controlled input states with fallback to saved data
  const [profile, setProfile] = useState(savedFormData.profile || '');
  const [name, setName] = useState(savedFormData.name || '');
  const [gender, setGender] = useState(savedFormData.gender || '');
  const [dob, setDob] = useState(savedFormData.dob || '');
  const [number, setNumber] = useState(savedFormData.number || '');
  const [email, setEmail] = useState(savedFormData.email || '');
  const [checked, setChecked] = useState(savedFormData.checked || false);

  // Error states
  const [errors, setErrors] = useState({});

  const userRegister = new UserRegister();

  // Save state to localStorage whenever any input changes
 useEffect(() => {
  const token = localStorage.getItem("token");
  if (token) {
    navigation('/Viewpage', { replace: true });
  }
}, [navigation]);
  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  function validate() {
    const newErrors = {};

    // Calculate age properly
    const dobDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();
    const dayDiff = today.getDate() - dobDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    if (!profile.trim()) newErrors.profile = 'Please Select Your Profile.';

    if (!name.trim()) {
      newErrors.name = 'Please Enter Your Name.';
    } else if (!/^[A-Za-z\s]+$/.test(name.trim())) {
      newErrors.name = 'Name should contain Alphabets only.';
    }

    if (!gender.trim()) newErrors.gender = 'Please Enter Your Gender.';

    if (!checked) newErrors.checked = 'Please Select the Terms and Conditions.';

    if (!dob.trim()) {
      newErrors.dob = 'Please Select Your Date Of Birth.';
    } else if (gender === 'Male' && age < 21) {
      newErrors.dob = 'Male candidates must be at least 21 years old.';
    } else if (gender === 'Female' && age < 18) {
      newErrors.dob = 'Female candidates must be at least 18 years old.';
    }

    if (!number.trim()) {
      newErrors.number = 'Please Enter Your Mobile Number.';
    } else if (!/^[0-9]{10}$/.test(number.trim())) {
      newErrors.number = 'Enter a valid 10-digit Mobile Number.';
    }

    if (!email.trim()) {
      newErrors.email = 'Please Enter Your Email';
    } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
      newErrors.email = 'Enter a Valid Email Address.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  useEffect(() => {
 
  const formData = { profile, name, gender, dob, number, email, checked };
  
  
  localStorage.setItem('profileFormData', JSON.stringify(formData));
}, [profile, name, gender, dob, number, email, checked]);

  async function handleSubmit() {
    if (validate()) {
      userRegister.matrimony_Profile_For = parseInt(profile, 10);
      userRegister.name = name.trim();
      userRegister.gender = gender;
      userRegister.date_Of_Birth = dob + "T00:00:00.000Z";

      userRegister.mobile_Number = await ApiConfig.encrypt(number.trim());
      userRegister.email_Id = await ApiConfig.encrypt(email.trim());

      await getAccountAPICall();
    }
  }

  async function getAccountAPICall() {
    try {
      const request = new LookUpRequest();
      request.mobile_number = await ApiConfig.encrypt(number.trim());
      request.email_Id = await ApiConfig.encrypt(email.trim());

      const response = await axios.post(
        ApiConfig.getUrl("User/mobilenumberverification"),
        JSON.stringify(request),
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      const count = response.data?.response?.registerList?.length ?? 0;
      const api = ApiResponse.fromJson(response.data);
      const accounts = RegisteredUserResponse.fromJson(api);

      if (api.status === true && api.statusCode === 200 && count > 0) {
        showToastFailed("The Email/Mobile number already exist!");
      } else if (api.statusCode === 201) {
        // Clear saved form data on successful submission before moving next
        localStorage.removeItem('profileFormData');
        navigation('/Place_screen', { state: { userRegister, isFromRegistration: true} });
      } else {
        showToastFailed(api.errorMessage || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error:", error);
      showToastFailed("An error occurred. Please try again.");
    }
  }

  const disableRightClick = (e) => {
    e.preventDefault();
  };

  function clickToTerms() {
    navigation("/TermsAndConditions", {
      state: { isFromRegistration: true }
    });
  }

  function clickToPrivacy() {
    navigation("/PrivacyPolicy", {
      state: { isFromRegistration: true }
    });
  }

  const handleClick = () => {
    window.open('https://drive.google.com/file/d/1kPhAxsI-zwHrVEp-zll4ckqZ6Z0ySucF/view?usp=drive_link', '_blank', 'noopener,noreferrer');
  };

  const handleProfileChange = (e) => {
    const val = e.target.value;
    setProfile(val);
    if (val === "1" || val === "3") {
      setGender("Male");
    } else if (val === "2" || val === "4") {
      setGender("Female");
    } else {
      setGender("");
    }
  };

  return (
    <>
      <div className='fullview' onContextMenu={disableRightClick} style={{ backgroundColor: "white" }}>
        <TopBar />
        <ToastContainer />
        <div className='container mt-5'>

          <div className='row mt-5 align-items-center gx-0'>
            <div className="col-lg-5 col-12 p-4 d-flex justify-content-center align-items-center mt-3">
              <img className='image h-100 w-100' src={logo} alt='logo' />
            </div>

            <div className="col-lg-6 card p-3">
              <p className="h5 text-center mt-2 pt-2">Find Your Perfect Match</p>

              <select id='profile' className="form-control mt-2" value={profile} onChange={handleProfileChange}>
                <option value="">--Select Profile--</option>
                <option value="1">Son</option>
                <option value="2">Daughter</option>
                <option value="3">Brother</option>
                <option value="4">Sister</option>
                <option value="5">Relative</option>
                <option value="6">Friend</option>
                <option value="7">Myself</option>
              </select>
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{errors.profile}</span>

              <input
                type="text"
                placeholder="Enter your Groom/Bride Name"
                className="form-control mt-2"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{errors.name}</span>

              <select
                id="gender"
                className="form-control mt-2"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                disabled={["1", "2", "3", "4"].includes(profile)}
              >
                <option value="">--Gender--</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{errors.gender}</span>

              <input
                type="date"
                className="form-control mt-2"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
              />
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{errors.dob}</span>

              <input
                type="text"
                placeholder="Enter Mobile Number"
                className="form-control mt-2"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>
                {errors.number}
              </span>

              <input
                type="email"
                placeholder="Email Address"
                className="form-control mt-2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{errors.email}</span>

              <div className='mt-1 ms-2 d-flex'>
                <input type='checkbox' id='agree' checked={checked} onChange={(e) => setChecked(e.target.checked)} />
                <label className='ms-2' htmlFor='agree'>
                  By continuing you agree to the <span className='text-primary' style={{ cursor: 'pointer' }} onClick={clickToTerms}>Terms and Condition</span> and <span className='text-primary' style={{ cursor: 'pointer' }} onClick={clickToPrivacy}>Privacy Policy.</span>
                </label>
              </div>
              <span className="text-danger text-decoration-none">{errors.checked}</span>

              <button onClick={handleSubmit} type="button" className="btn w-100 mt-4 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}>
                Register Free →
              </button>
            </div>

            <span className='center fs-1' style={{ cursor: 'pointer' }} onClick={handleClick}>Download the App</span>
          </div>

          <Offeradd />
        </div>
      </div>

      {/* Why Choose Section */}
      <section className="why-matrimony-section mt-2 container">
        <div className="text-center mb-5">
          <div className="why-small-title">
            ◉ &nbsp; Why IndiaMetti Matrimony
          </div>

          <h2 className="why-title">
            Why Choose IndiaMetti Matrimony?
          </h2>

          <p className="why-subtitle">
            Four pillars that make us the trusted choice for Tamil families seeking a marriage alliance.
          </p>
        </div>

        <div className="row g-3 align-items-stretch">
          <div className="col-lg-6 col-md-12">
            <div className="verified-card h-100">
              <div className="verified-icon">
                <i className="bi bi-people"></i>
              </div>

              <h3>Verified Profiles</h3>

              <p>
                Every matrimonial profile is carefully verified to help you connect with genuine brides and grooms across India.
              </p>

              <div className="verified-list">
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Identity verified
                </div>
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Manual Document Verified
                </div>
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Family-friendly
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="row g-3 h-100">
              <div className="col-md-6">
                <div className="why-feature-card h-100">
                  <div className="feature-icon secure-icon">
                    <i className="bi bi-lock"></i>
                  </div>
                  <h5>Secure &amp; Private</h5>
                  <p>Your data is secure and protected</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="why-feature-card h-100">
                  <div className="feature-icon search-icon">
                    <i className="bi bi-search"></i>
                  </div>
                  <h5>Advanced Search</h5>
                  <p>Find brides and grooms based on your preferences</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="why-feature-card h-100">
                  <div className="feature-icon heart-icon">
                    <i className="bi bi-heart"></i>
                  </div>
                  <h5>Smart Matching</h5>
                  <p>Find your life partner for marriage with ease</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="why-feature-card h-100">
                  <div className="feature-icon aadhaar-icon">
                    <i className="bi bi-patch-check"></i>
                  </div>
                  <h5>Verified Profiles</h5>
                  <p>Optional verification badge for added trust.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="row text-center why-stats mt-5 border">
          <div className="col-6 col-md-3">
            <div className="stat-number">100%</div>
            <div className="stat-label">Verified Profiles</div>
          </div>

          <div className="col-6 col-md-3">
            <div className="stat-number">50+</div>
            <div className="stat-label">Communities</div>
          </div>

          <div className="col-6 col-md-3">
            <div className="stat-number">28+</div>
            <div className="stat-label">Indian States</div>
          </div>

          <div className="col-6 col-md-3">
            <div className="stat-number">Quick</div>
            <div className="stat-label">Customer Support</div>
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="location-section mt-0 container">
        <div className="row align-items-start">
          <div className="col-lg-4 col-md-12">
            <div className="location-small-title">
              <i className="bi bi-geo-alt"></i>
              Serving Across India &amp; Worldwide
            </div>

            <h2 className="location-title">
              Find Brides &amp; Grooms
              <br />
              Everywhere
            </h2>

            <p className="location-description">
              Connect with genuine matrimonial profiles from all regions across India and abroad. Find brides and grooms based on your preferred Locations region, community, language, and lifestyle.
            </p>
          </div>

          <div className="col-lg-8 col-md-12 mt-1 mt-lg-0">
            <div className="row g-3">
              <div className="col-6 col-md-3">
                <div className="city-card city-chennai">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-geo-alt"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>North India</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-madurai">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-geo-alt"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>South India</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-coimbatore">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-geo-alt"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>West India</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-trichy">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-geo-alt"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>East India</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-salem">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-geo-alt"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>Central India</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-tirunelveli">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-geo-alt"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>NRI / Abroad</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-erode">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-globe2"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>All Regions</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-chennai">
                  <div className="city-top">
                    <div className="city-icon"><i className="bi bi-globe2"></i></div>
                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>
                  <h5>All Castes</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section container">
        <div className="services-heading text-center">
          <div className="services-small-title">
            ✦ &nbsp; Our Services
          </div>

          <h2>IndiaMetti Matrimony Services</h2>
          <p>
            Complete matrimonial solutions designed to help individuals and families find meaningful marriage alliances across India.
          </p>
        </div>

        <div className="row g-4 mt-4">
          <div className="col-lg-6 col-md-12">
            <div className="service-card location-service">
              <div className="service-card-header">
                <div className="service-icon"><i className="bi bi-geo-alt"></i></div>
                <div>
                  <div className="service-label">LOCATION</div>
                  <h3>Matrimony Across India</h3>
                </div>
              </div>

              <div className="service-content">
                <p>
                  IndiaMetti Matrimony connects brides and grooms from cities, towns, and communities across India. Discover genuine matrimonial profiles based on your preferences.
                </p>

                <div className="service-points">
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Verified profiles from across India</span>
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Community and language-based search</span>
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Professional and educated profiles</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="service-card profession-service">
              <div className="service-card-header">
                <div className="service-icon"><i className="bi bi-briefcase"></i></div>
                <div>
                  <div className="service-label">PROFESSION</div>
                  <h3>Profession-Based Matrimony</h3>
                </div>
              </div>

              <div className="service-content">
                <p>
                  Find brides and grooms by profession and career preferences — Engineering, Doctor, Teacher, IT Professional, Government Employee, Business Professionals, and many more.
                </p>

                <div className="profession-list">
                  <div className="profession-item engineer">
                    <i className="bi bi-code-slash"></i>
                    <span>Engineers</span>
                  </div>
                  <div className="profession-item doctor">
                    <i className="bi bi-heart-pulse"></i>
                    <span>Doctors</span>
                  </div>
                  <div className="profession-item teacher">
                    <i className="bi bi-book"></i>
                    <span>Teachers</span>
                  </div>
                  <div className="profession-item it">
                    <i className="bi bi-code"></i>
                    <span>IT Professionals</span>
                  </div>
                  <div className="profession-item business">
                    <i className="bi bi-building"></i>
                    <span>Business</span>
                  </div>
                  <div className="profession-item government">
                    <i className="bi bi-bank"></i>
                    <span>Government Jobs</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className='bg-dark text-white text-center py-2'>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>
  );
}

export default Profile;